module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order-deleted"
  }, [_c('h1', {
    staticClass: "order-deleted-title"
  }, [_vm._v(_vm._s(_vm.$t("orders.title")) + " " + _vm._s(_vm.orderData.reference))]), _vm._v(" "), _c('div', {
    staticClass: "order-deleted-content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("orders.deleteOrder.hasDeleted")))]), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "btn btn-client2",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.deleteOrder.btnListOrder")))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b297ac3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrderMain/OrderDeleted.vue
// module id = 3166
// module chunks = 0